<div class="footer d-flex justify-content-center align-items-center">
    <div class="footer-controls mb-md-0 footer-controls-top">
        @if(isDevelopment) {
        <div class="theme-toggle-wrapper">
            <ppl-button
                [icon]="isDarkTheme ? 'fa fa-sun-o' : 'fa fa-moon-o'"
                [ariaLabel]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
                [hideLabel]="true"
                customClass="ghost-button rounded theme-toggle-btn"
                size="small"
                (handleClick)="toggleDarkTheme()"
                [title]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
            ></ppl-button>
        </div>
        }
        <div class="footer-font">
            <app-font-selector></app-font-selector>
        </div>
        <div class="footer-translate">
            <ppl-google-translate></ppl-google-translate>
        </div>
    </div>
    <div class="footer-links mb-md-0">
        <a href="https://www.pplfirst.com/privacy-policy/" target="_blank">Privacy Policy</a>
        <a href="https://www.pplfirst.com/terms-of-use/" target="_blank">Terms of Use</a>
    </div>
    <div class="copyright mb-md-0">
        Copyright © 2026 PPL CareConnect All rights reserved.
    </div>
</div>
